import { useCallback } from 'react';

import useColor from '@/hooks/domain/useColor';
import useTagStore from '@/stores/TagStore';
import { getChartColorByHash } from '@/styles/colors/chartColors';

import { InsightExplorerFieldType } from '../types/constants';

const useExplorerColor = (by: InsightExplorerFieldType) => {
  const tagMap = useTagStore((state) => state.tagMap);
  const color = useColor();

  const getLabelColor = useCallback(
    (seg: StringNumberValue): string => {
      const hashKey: string = String(seg) || '';

      switch (by) {
        case InsightExplorerFieldType.TAG: {
          const tag = tagMap[seg];
          if (!tag) return color.gray500;
          return color.profile[(tag.color - 1 || 0) % color.profile.length];
        }
        default: {
          return getChartColorByHash(hashKey);
        }
      }
    },
    [by, tagMap, color],
  );

  return getLabelColor;
};

export default useExplorerColor;
